export const HUMAN_DATE_FORMAT = 'MMM DD, YYYY';

export const APP_PROXY_URL =
  process.env.APP_PROXY_URL || '/tools/bundle-subscriptions';

const API_BASE_URL_PROD = 'https://shapi.bundlepayments.com';
const API_BASE_URL_QA = 'https://shapi.bundleqa.com';
const API_BASE_URL_DEV = 'http://localhost:8082';

export const API_BASE_URL =
  {
    qa: API_BASE_URL_QA,
    production: API_BASE_URL_PROD,
    dev: API_BASE_URL_DEV,
  }[process.env.BUNDLE_ENV || 'production'] || API_BASE_URL_PROD;

export enum ProductSwapTypes {
  VARIANT,
  PRODUCT,
  BUNDLE,
}

export const PRODUCT_CHANGE_OPTIONS = {
  ANY_PRODUCT: 'ANY_PRODUCT',
  SAME_PRODUCT: 'SAME_PRODUCT',
  SAME_SUBSCRIPTION: 'SAME_SUBSCRIPTION',
  NOT_ALLOWED: 'NOT_ALLOWED',
};
